export default "__VITE_ASSET__BbKUSvSx__"